"use client";

export function LogoFallback() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-gradient-to-b from-sky-700 to-emerald-900">
      <div className="text-3xl font-black tracking-tight text-white">
        Voxel<span className="text-emerald-300">Planet</span>
        <span className="text-white/60">.de</span>
      </div>
      <div className="mt-4 h-8 w-8 animate-spin rounded-full border-2 border-white/30 border-t-emerald-300" />
      <div className="mt-3 font-mono text-xs text-white/60">Loading engine…</div>
    </div>
  );
}
